import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { getPartsAll } from '../partsThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
const SLICE_NAME = 'partsAll';

export const partsAllSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: builder => {
        handleRequestThunk({ builder, request: getPartsAll });
    },
});

export const partsAll = partsAllSlice.reducer;
